import React, { useState } from "react";
import "./Header.css";
import { Container, Nav, Navbar } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Enquiry_Form_Modal from "../common_components/common_modal/Enquiry_Form_Modal/Enquiry_Form_Modal";
import { faDownload, faPhoneVolume } from "@fortawesome/free-solid-svg-icons";

function Header({ scrollToSection }) {
  const [showModal, setShowModal] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  const [expanded, setExpanded] = useState(false); 

  const handleNavClick = () => {
    setExpanded(false);
  };

  const navItems = [
    { label: "Home", path: "/" },
    { label: "About", path: "/about-us" },
    { label: "Programmes", path: "/programmes" },
    { label: "Blogs", path: "/blogs" },
    { label: "Contact Us", path: "/contact-us" },
    { label: "Admissions", path: "/admissions" },
  ];

  return (
    <>
      <section className="Header">
        <div className="inquirybtndiv">
          {/* <button className="inquirybtn" onClick={() => { setShowModal(true) }}>Inquire Now</button> */}
           <a href="tel:+919607755557" className="inquirybtn">           
              <FontAwesomeIcon icon={faPhoneVolume} className="me-3" /> CALL US            
          </a>
          {/* <button
            className="inquirybtn"
            onClick={() => {
              setShowModal(true);
            }}
          >
            <FontAwesomeIcon icon={faDownload} className="me-3" />
            DOWNLOAD BROCHURE
          </button> */}
        </div>

        <Container>
          <div className={`main_menu_navbar`}>
            <Navbar expand="md">
              <div className="logo_holder">
                <Link to="/">
                  <img
                    src={
                      process.env.PUBLIC_URL + "/assets/images/logo/logo.png"
                    }
                    alt="logo"
                    className="nav_logo"
                    onClick={() => navigate("/")}
                  />
                </Link>
              </div>

              <div className="mobile_logo_holder_2">
                <Link to="/">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/assets/images/logo/right-head-logo.png"
                    }
                    alt="logo"
                    className="new_logo"
                    onClick={() => navigate("/")}
                  />
                </Link>
                <div className="number_class">
                  <a href="tel:+919607755557">
                    <FontAwesomeIcon icon={faPhoneVolume} />
                    +91 9607755557
                  </a>
                </div>
              </div>

              <Navbar.Toggle aria-controls="basic-navbar-nav" />

              <Navbar.Collapse id="basic-navbar-nav">
                <div className="top_bar">
                  <Nav>
                    {/* {navItems.map((item, index) => ( */}
                    <Nav.Link
                      as={Link}
                      to="/"
                      className={location.pathname === "/" ? "active" : ""}
                    >
                      Home
                    </Nav.Link>

                    <Nav.Link
                      onClick={() => {
                        setShowModal(true);
                      }}
                    >
                      Programs
                    </Nav.Link>

                    <Nav.Link
                      onClick={() => {
                        setShowModal(true);
                      }}
                    >
                      {" "}
                      Admissions
                    </Nav.Link>

                    <Nav.Link
                      onClick={() => {
                        setShowModal(true);
                      }}
                    >
                      {" "}
                      Contact Us
                    </Nav.Link>

                    {/* ))} */}
                  </Nav>
                </div>
              </Navbar.Collapse>

              <div className="desk_logo_holder_2">
                <Link to="/">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/assets/images/logo/right-head-logo.png"
                    }
                    alt="logo"
                    className="new_logo"
                    onClick={() => navigate("/")}
                  />
                </Link>
                <div className="number_class">
                  <a href="tel:+919607755557">
                    <FontAwesomeIcon icon={faPhoneVolume} />
                    +91 9607755557
                  </a>
                </div>
              </div>
            </Navbar>
          </div>
        </Container>

        <Enquiry_Form_Modal
          show={showModal}
          onHide={() => {
            setShowModal(false);
          }}
        />
      </section>
    </>
  );
}

export default Header;
